// eslint-disable-next-line import/no-anonymous-default-export
export default (text) => {
  if (!text) return;

  return text.replace(/\n{2,}\s*/g, '\n').replace(/\n+$/g, '');
};
